import { Grid, Typography } from '@mui/material';
import { ICreateAudienceButton } from './types';

import PlusIcon from 'assets/icons/buttons/add-custom.svg';
import { styles } from './styles';

export const CreateAudienceButton = ({ onClick }: ICreateAudienceButton) => {
  return (
    <Grid sx={styles.container} onClick={onClick}>
      <PlusIcon />
      <Typography sx={styles.createAudienceText}>Create Custom Audience</Typography>
    </Grid>
  );
};
